//  weaver API endpoints.  Created to consolidate future endpoint constants
import { apiUrlForRequiredAuth, MAMI_SERVER_V2 } from './utils';

//* Clinician: src/api/clinician/index.ts //* -------------------------------------
export const CLINICIAN_URL = () => apiUrlForRequiredAuth('v1/clinician'); // clinician

//* staff clinician-v2: src/api/v2/clinician/index.ts //* -------------------------------------
export const DEFAULT_PAGINATION_LIMIT = '50';
export const CLINIC_ADMIN_PATIENT_ADHERENCE_URL_V2 = () =>
  apiUrlForRequiredAuth('v2/clinic-admin/patient-adherence');

//* tracking: src/api/v2/tracking/index.ts //* -------------------------------------
export const TRACK_EVENT_URL_V2 = () => `${MAMI_SERVER_V2()}/track`; // tracking

//* orders: src/api/order/index.ts //* -------------------------------------
export const CREATE_ORDER_URL = () => apiUrlForRequiredAuth('v2/orders');
